import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,

        gyseFormIsOpen: false,
        gyseGridIsOpen: true,

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új javaslat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-prescription-bottle-alt"></i> Termék kiválasztása',
                event_name: "customClick",
                class: "btn btn-info mx-1",
                event_payload: 'openDrugSelectDialog'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-cloud-upload-alt"></i>',
                title: 'Feltöltés EESZT-be',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                additionalButtonVisible: "isShowUploadToEesztSpecialRecommendation",
                event_payload: 'uploadEeszt'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "attendanceId",
                label: "Kezelés azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "drugId",
                label: "Gyógyszer azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "bnoId",
                label: "BNO azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "eupontId",
                label: "EÜ. pont azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "termekNev",
                label: "Termék név",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 5
            },
            {
                name: "oepTtt",
                label: "TTT kód",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 3
            },
            {
                name: "hataserosseg",
                label: "Hatáserősség",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "beviteliMod",
                label: "Beviteli mód",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "indPontSzam",
                label: "Indikációs pont sorszáma",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "tamSzazMertek",
                label: "Tám. száz. mértéke",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "recommendationDuration",
                label: "Jav. időtartama (hónap)",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "rowBreak",
                label: "rowBreak",
                rowBreak: true,
                visibility: false,
                formSize: 4,
                formVisible: true
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "select",
                formSize: 2,
                selectOptions: {
                    apiCallback: Api.getJogcimList,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "bnoKod",
                label: "BNO kód",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "bnoKodText",
                label: "BNO név",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 4
            },
            {
                name: "recommendationDate",
                label: "Javaslat kelte",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "date",
                formSize: 2
            },
            {
                name: "recommendedDosage",
                label: "Javasolt adagolás",
                visibility: false,
                formVisible: true,
                formType: "text",
                formSize: 3,
                formRequired: true
            },
            {
                name: "eesztId",
                label: "EESZT azonosító",
                visibility: false,
                formVisible: false,
                formType: "text",
                formReadOnly: true,
                formSize: 2
            },
            {
                name: "esemenykatalogusEesztId",
                label: "Eseménykatalógus EESZT azonosító",
                visibility: false,
                formVisible: false,
                formType: "text",
                formReadOnly: true,
                formSize: 2
            },
            {
                name: "bnoCode.kod",
                label: "BNO kód",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "bnoCode.leiras",
                label: "BNO",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "drug.oepNev",
                label: "Termék",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: false
            },
            {
                name: "eupontok.assistanceType",
                label: "Támogatás",
                visibility: true,
                formVisible: false
            },
            {
                name: "eupontok",
                label: "Eü. pont",
                visibility: true,
                slot_name: "eupont_format",
                formVisible: false
            },
            {
                name: "recommendationDate",
                label: "Javaslat dátuma",
                slot_name: "date_format",
                visibility: true,
                formVisible: false
            },
            {
                name: "recommendedDosage",
                label: "Javasolt adagolás",
                visibility: true,
                slot_name: "recommendedDosageFormat",
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        gyseActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új javaslat',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newGyseRow'
            }
        ],
        gyseFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGyseGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetGyseForm'
            }
        ],
        gyseRowActions: [
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                additionalButtonVisible: "isShowPrintFromEesztSpecialRecommendation",
                event_payload: 'printGyseRow'
            },
            {
                btn_text: '<i class="fas fa-cloud-upload-alt"></i>',
                title: 'Feltöltés EESZT-be',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                additionalButtonVisible: "isShowUploadToEesztSpecialRecommendation",
                event_payload: 'uploadGyseEeszt'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteGyseRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteGyseRow'
            }
        ],
        gyseHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "attendanceId",
                label: "Kezelés azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "bnoCodesText",
                label: "BNO",
                formVisible: false,
                visibility: true
            },
            {
                name: "isoCodesText",
                label: "ISO",
                formVisible: false,
                visibility: true
            },
            {
                name: "bnoCodes",
                label: "BNO",
                visibility: false,
                formRequired: true,
                formVisible: true,
                formSize: 6,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getBnoForSelect,
                    formatOption: function (val) {
                        return val.leiras + ' (' + val.kod + ')';
                    },
                    minimumInputLength: 3,
                    searchOnServer: true,
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "szakkepesitesek",
                label: "Szakképesítések",
                visibility: false,
                formRequired: true,
                formVisible: true,
                formSize: 6,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getSzakvKodok,
                    formatOption: function (val) {
                        return val.leiras;
                    },
                    filteredAttr: 'leiras',
                    minimumInputLength: 0,
                    searchOnServer: false,
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "isoCodes",
                label: "ISO",
                visibility: false,
                formRequired: true,
                formVisible: true,
                formSize: 6,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllPuphaIso,
                    formatOption: function (val) {
                        return val.megnevezes + " (" + val.iso + ")";
                    },
                    filteredAttr: 'megnevezes',
                    minimumInputLength: 0,
                    searchOnServer: false,
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "diagnoseText",
                label: "Diagnózis",
                visibility: false,
                formVisible: true,
                formType: "textarea",
                formSize: 6
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: false,
                formVisible: true,
                formType: "textarea",
                formSize: 6
            },
            {
                name: "titleId",
                label: "Jogcím",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formType: "select",
                formSize: 2,
                selectOptions: {
                    externalOptionList: [
                        {id: 15601, text: 'Normatív'},
                        {id: 15603, text: 'Eü emelt'},
                        {id: 15604, text: 'Eü kiemelt'},
                        {id: 15606, text: 'KGY+Eü emelt'},
                        {id: 15607, text: 'KGY+Eü kiemelt'}],
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "aidCategory",
                label: "Támogatási kategória",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formType: "select",
                formSize: 2,
                selectOptions: {
                    externalOptionList: [
                        {id: '50%', text: '50%'},
                        {id: '70%', text: '70%'},
                        {id: '80%', text: '80%'},
                        {id: '90%', text: '90%'},
                        {id: '98%', text: '98%'},
                        {id: 'FIX', text: 'FIX'}
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "quantity",
                label: "Mennyiség",
                visibility: true,
                formVisible: true,
                formType: "number",
                formSize: 2,
                formRequired: true
            },
            {
                name: "quantityUnit",
                label: "Mennyiség egység",
                visibility: true,
                formVisible: true,
                formType: "select",
                formSize: 2,
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getReceptFelirasMennyisegiEgysegeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "recommendationDate",
                label: "Javaslat kelte",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "date",
                formSize: 2
            },
            {
                name: "validTo",
                label: "Javaslat érvényessége",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formType: "date",
                formSize: 2
            },
            {
                name: "eesztId",
                label: "EESZT azonosító",
                visibility: false,
                formVisible: false,
                formType: "text",
                formReadOnly: true,
                formSize: 2
            },
            {
                name: "esemenykatalogusEesztId",
                label: "Eseménykatalógus EESZT azonosító",
                visibility: false,
                formVisible: false,
                formType: "text",
                formReadOnly: true,
                formSize: 2
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

    }
}
